<template>
  <div id="form-step">
    <b-row class="row">
      <b-col cols="5">
        <text-input :label="$t('CNTRCT_ID')" v-model='contractMifosId' disabled borderbottom placeholder=""/>
      </b-col>
      <b-col cols="2"></b-col>
      <b-col cols="5">
        <text-input
          :label="$t('OUTSTANDING_FEE')"
          v-model='info.totalOutstanding'
          :hint="changeDigitToViText(info.totalOutstanding)"
          disabled
          borderbottom
          placeholder=""
        />
      </b-col>
    </b-row>
    <b-row class="row">
      <b-col cols="5">
        <toggle-box ref="transactionDateBox">
          <template v-slot:control>
            <text-input
              v-model="info.transactionDate"
              :label="$t('TRANSACTION_DATE')"
              icon-position="right"
              disabled
              borderbottom
              placeholder=""
            >
              <template v-slot:icon>
                <font-awesome-icon @click="showTransactionDateBox" class="icon" :icon="faCalendarAlt" />
              </template>
            </text-input>
          </template>
          <template v-slot:content>
            <calendar
              :date="transactionDateMoment"
              @dateChange="setTransactionDate"
            />
          </template>
        </toggle-box>
      </b-col>
      <b-col cols="2"></b-col>
      <b-col cols="5">
        <text-input
          :label="$t('OVERDUE_FEE')"
          v-model="overdueFee"
          :hint="changeDigitToViText(overdueFee)"
          disabled
          borderbottom
          placeholder=""
        />
      </b-col>
    </b-row>
    <b-row class="row">
      <b-col cols="5">
        <text-input
          :label="$t('MATURITY_DATE')"
          v-model="info.dueDate"
          icon-position="right"
          disabled
          borderbottom
          placeholder=""
        >
        </text-input>
      </b-col>
      <b-col cols="2"></b-col>
      <b-col cols="5">
        <text-input :label="$t('LATE_DAY_NUMBER')" v-model="lateDays" disabled borderbottom placeholder=""/>
      </b-col>
    </b-row>
    <b-row class="row">
      <b-col cols="5">
        <text-input
          :label="$t('PRINCIPAL')"
          v-model="info.principalAmount"
          :hint="changeDigitToViText(info.principalAmount)"
          disabled
          borderbottom
          placeholder=""
        />
      </b-col>
      <b-col cols="2"></b-col>
      <b-col cols="5">
        <text-input
          :label="$t('DISCOUNT_MONEY')"
          v-model="info.promotionAmount"
          :hint="changeDigitToViText(info.promotionAmount)"
          disabled borderbottom
          placeholder=""
        />
      </b-col>
    </b-row>
    <b-row class="row">
      <b-col cols="5">
        <text-input
          :label="$t('INTEREST')"
          v-model="info.interestAmount"
          :hint="changeDigitToViText(info.interestAmount)"
          disabled
          borderbottom
          placeholder=""
        />
      </b-col>
      <b-col cols="2"></b-col>
      <b-col cols="5">
        <text-input
          :label="$t('TOTAL_AMOUNT')"
          v-model="totalAmount"
          :hint="changeDigitToViText(totalAmount)"
          disabled
          borderbottom
          placeholder=""
        />
      </b-col>
    </b-row>
    <b-row class="row">
      <b-col cols="7"></b-col>
      <b-col cols="5" class="panel">
        <div class="bottom d-flex justify-content-start">
          <label class="label">{{ $t('PAYMENT_METHOD') }}</label>
          <label :key="index" v-for="(method, index) in PAYMENT_METHODS" class="label-button">{{ $t(method) }}
            <input type="radio" name="radio" :value="method" v-model="paymentMethod">
            <span class="checkmark"></span>
          </label>
        </div>
      </b-col>
    </b-row>
    <div class="d-flex justify-content-end">
      <primary-button @click="back" class="button" white rounded-corner :text="$t('BACK')" />
      <primary-button @click="next" class="button" rounded-corner :text="$t('NEXT')" />
    </div>
  </div>
</template>

<script>
import Calendar from '@/components/Calendar';
import TextInput from '@/components/TextInput';
import ToggleBox from '@/components/ToggleBox';
import PrimaryButton from '@/components/PrimaryButton';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { computed, onMounted } from '@vue/composition-api';
import moment from 'moment';
import { changeDigitToViText } from '@/helpers';

import { DATE_FORMAT, DISPLAY_DATE_FORMAT } from '@/consts';

const { useState, useActions, useGetters } = createNamespacedHelpers('contractRedeem');

const PAYMENT_METHODS = ['CASH', 'BANK_TRANSFER'];

export default {
  name: 'FormComponent',
  components: {
    TextInput,
    Calendar,
    ToggleBox,
    FontAwesomeIcon,
    PrimaryButton,
  },
  setup(props, { root, emit, refs }) {
    const { id: contractMifosId } = root.$route.params;

    const { info } = useState(['info']);

    const { lateDays, overdueFee, totalAmount } = useGetters(['lateDays', 'overdueFee', 'totalAmount']);

    const { getContractRedeemInfo, setInfo } = useActions(['getContractRedeemInfo', 'setInfo']);

    const paymentMethod = computed({
      get: () => info.value.paymentMethod,
      set: (val) => setInfo({ paymentMethod: val }),
    });

    const transactionDateMoment = computed(() => moment(info.value.transactionDate, DISPLAY_DATE_FORMAT));

    const showTransactionDateBox = () => {
      refs.transactionDateBox.toggle(true);
    };

    const setTransactionDate = (val) => {
      setInfo({ transactionDate: moment(val, DATE_FORMAT).format(DISPLAY_DATE_FORMAT) });
      refs.transactionDateBox.toggle(false);
    };

    onMounted(() => {
      getContractRedeemInfo(contractMifosId);
    });

    const back = () => { emit('back'); };

    const next = () => { emit('next'); };

    return {
      PAYMENT_METHODS,
      contractMifosId,
      info,
      lateDays,
      overdueFee,
      totalAmount,
      paymentMethod,
      transactionDateMoment,
      showTransactionDateBox,
      setTransactionDate,
      changeDigitToViText,
      next,
      back,
      faCalendarAlt,
    };
  }
};
</script>

<style lang='scss' scoped>
@import "~@/assets/scss/colors";

#form-step {
  padding: 57px 80px 33px;
  background-color: $white;
  border-radius: 8px;

  .row {
    margin-bottom: 30px;
  }

  .label {
    font-weight: bold;
    color: #ccc;
    font-size: 14px;
    margin-bottom: 0px;
  }

  .panel {
    position: relative;
    margin-top: 20px;
  }

  .bottom {
    position: absolute;
    bottom: 6px;
  }

  .icon {
    cursor: pointer;
  }

  /* The container */
  .label-button {
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 0px;
    cursor: pointer;
    font-size: 14px;
    color: $trout;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default radio button */
  .label-button input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: $iron;
    border-radius: 50%;
    margin-left: 5px;
  }

  /* On mouse-over, add a grey background color */
  .label-button:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the radio button is checked, add a blue background */
  .label-button input:checked ~ .checkmark {
    background-color: $alizarinCrimson;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .label-button input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .label-button .checkmark:after {
    top: 6px;
    left: 6px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: $white;
  }

  .button {
    margin-left: 20px;
    box-shadow: 0px 3px 6px $silver;
  }
}
</style>
